var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCheckSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 72C55.8844 72 72 55.8844 72 36C72 16.1156 55.8844 0 36 0C16.1156 0 0 16.1156 0 36C0 55.8844 16.1156 72 36 72ZM51.8906 29.3906L33.8906 47.3906C32.5687 48.7125 30.4313 48.7125 29.1234 47.3906L20.1234 38.3906C18.8016 37.0687 18.8016 34.9313 20.1234 33.6234C21.4453 32.3156 23.5828 32.3016 24.8906 33.6234L31.5 40.2328L47.1094 24.6094C48.4313 23.2875 50.5687 23.2875 51.8766 24.6094C53.1844 25.9312 53.1984 28.0687 51.8766 29.3766L51.8906 29.3906Z",
    fill: "#54A64D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCheckSuccess);
export default __webpack_public_path__ + "static/media/creditCheck-success.5131ef29e8d4114343419e67c3841bfd.svg";
export { ForwardRef as ReactComponent };